import { render, staticRenderFns } from "./M_triggerConfig.vue?vue&type=template&id=28df1dca&scoped=true&"
import script from "./M_triggerConfig.vue?vue&type=script&lang=js&"
export * from "./M_triggerConfig.vue?vue&type=script&lang=js&"
import style0 from "./M_triggerConfig.vue?vue&type=style&index=0&id=28df1dca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28df1dca",
  null
  
)

export default component.exports